<div class="gcontainer accounting-container" #accountingpage>
  <div class="r-header-wrapper">
    <!-- Breadcrumb-->
    <div class="no-print">
      <nav aria-label="breadcrumb" class="bredcrums">
        <ol class="breadcrumb">
          <li class="breadcrumb-item active breadcrumb cursor" aria-current="page">
            <a class="c-primary" [routerLink]="'/dashboard'" tabindex="0"> Dashboard </a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">Manage Billing</li>
        </ol>
      </nav>
    </div>
    <!-- Header Title-->
    <div class="row">
      <div class="col-10">
        <h1 class="header-title">Manage Billing</h1>
        @if (roleCheck(['Manager', 'Admin', 'Accounting'])) {
          <app-customer-attachments
            [projectId]="projectId"
            [backgroundClass]="'none'"
            [showSuccess]="false"
          style="vertical-align: middle; margin-right: 16px"></app-customer-attachments>
        }
      </div>
    </div>

    <div class="col-md-12">
      <div class="row accounting-details">
        <div class="col-6">
          <form [formGroup]="form">
            @if (billingData) {
              <div class="billing-container">
                <div class="section-row col-md-12 header">
                  <div class="col-6 label">
                    <h2>Billing Details</h2>
                  </div>
                  @if (billingData?.billing?.rushTesting) {
                    <div class="col-2 rush-indicator">
                      <mat-chip class="chipset-warning float-right">
                        <img
                          src="./../../../assets/icons/rush-warning-icon.svg"
                          class="icon-position"
                          alt="Rush-Testing-Warning" />
                          <span class="chip-text"> Rush</span>
                        </mat-chip>
                      </div>
                    }
                    @if (billingData?.billing?.routeThermalSurvey) {
                      <div class="col-4 ">
                        <mat-chip class="chipset-green float-right" >
                          <img
                            src="./../../../assets/icons/pre-approval-tick.svg"
                            class="icon-position"
                            alt="Geo-Testing-Success" />
                            <span class="text-white chip-text">Geotherm Field Testing </span>
                          </mat-chip>
                        </div>
                      }
                    </div>
                    <mat-divider></mat-divider>
                    <div class="content">
                      <div class="toggle-row">
                        <span class="label">Non-Billable/ Prepaid</span>
                        <div [ngClass]="{ 'bill-btn-disabled': !(roleCheck(['Accounting']) || roleCheck(['Admin'])) }">
                          <mat-slide-toggle
                            formControlName="isNonBillable"
                            (change)="onNonBillableToggle($event)">
                          </mat-slide-toggle>
                        </div>
                      </div>
                      <mat-divider></mat-divider>
                      @if (!isNonBillable) {
                        <div>
                          <div class="section-row col-md-12">
                            <div class="col-9 label">
                              <mat-label>Payment Terms</mat-label>
                            </div>
                            <div class="col-3">
                              <mat-form-field
                                appearance="outline"
                                class="payment-terms"
                                [ngClass]="{ 'disabled-input': !(roleCheck(['Accounting']) || roleCheck(['Admin'])) }">
                                <mat-select formControlName="paymentTerms">
                                  @for (payment of samplePayments; track payment) {
                                    <mat-option
                                      [value]="payment.id"
                                      [disabled]="payment.disabled">
                                      {{ payment.label }}
                                    </mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>
                          <mat-divider></mat-divider>
                          <div class="toggle-row">
                            <span class="label">Route Thermal Survey</span>
                            <mat-slide-toggle
                              formControlName="routeThermalSurvey"
                              color="primary">
                            </mat-slide-toggle>
                          </div>
                          <mat-divider></mat-divider>
                          @if (projectRates && projectRates.controls.length > 0) {
                            <div class="section-rate col-md-12">
                              <div class="col-6"></div>
                              <div class="col-2 qty-rate">
                                <mat-label>QTY</mat-label>
                              </div>
                              <div class="col-2 qty-rate">
                                <mat-label>Rate</mat-label>
                              </div>
                              <div class="col-2 qty-rate">
                                <mat-label>Amount</mat-label>
                              </div>
                            </div>
                          }
                          <!-- Dynamically Render Rates -->
                          <div formArrayName="projectRates">
                            @if (projectRates && projectRates.controls.length > 0) {
                              <div>
                                @for (rateGroup of projectRates.controls; track rateGroup; let i = $index) {
                                  @if (!rateGroup.get('routeSurvey')?.value) {
                                    <div
                                      [formGroupName]="i"
                                      class="section-rate-table col-md-12"
                                      >
                                      <div class="col-5 rate-input-label">
                                        @if (
                                          roleCheck(['Admin']) || roleCheck(['Accounting']) && rateGroup.get('disable')?.value === false) {
                                          <mat-form-field
                                            appearance="outline"
                                            class="input-field-label">
                                            <input
                                              matInput
                                              type="text"
                                              formControlName="rateName"
                                              maxlength="50"
                                              placeholder="Rate Name" />
                                            </mat-form-field>
                                          }
                                          @if (
                                            !(roleCheck(['Admin']) || roleCheck(['Accounting']) && rateGroup.get('disable')?.value === false)) {
                                            <span
                                              class="label">
                                              {{ rateGroup.get('rateName')?.value }}
                                            </span>
                                          }
                                        </div>
                                        <div class="col-2 rate-input">
                                          <mat-form-field
                                            appearance="outline"
                                            class="input-field"
                                            [ngClass]="{ 'disabled-input': !(roleCheck(['Admin']) || roleCheck(['Accounting'])) }">
                                            <input
                                              matInput
                                              type="text"
                                              formControlName="qty"
                                              maxlength="3"
                                              placeholder="Qty"
                                              (input)="recalculateAmounts()"
                                              (keypress)="allowOnlyNumbers($event)" />
                                            </mat-form-field>
                                          </div>
                                          <div class="col-2 rate-input">
                                            <mat-form-field
                                              appearance="outline"
                                              class="input-field"
                                              [ngClass]="{ 'disabled-input': !(roleCheck(['Admin']) || roleCheck(['Accounting'])) }">
                                              <input
                                                matInput
                                                formControlName="rate"
                                                placeholder="Rate"
                                                (input)="recalculateAmounts()"
                                                (keypress)="decimalFilter($event)" />
                                              </mat-form-field>
                                            </div>
                                            <div class="col-1 dollar-symbol"><span>$</span></div>
                                            <div class="col-2 rate-input-amount">
                                              <mat-form-field appearance="outline" class="input-field">
                                                <input matInput type="number" [value]="calculateAmount(i)" disabled />
                                              </mat-form-field>
                                            </div>
                                            @if (
                                              rateGroup.get('disable')?.value === false && roleCheck(['Admin'])
                                              ) {
                                              <div
                                                class="col-1 remove-btn"
                                                >
                                                <mat-icon class="close-icon" (click)="removeRate(i)">close</mat-icon>
                                              </div>
                                            }
                                          </div>
                                        }
                                      }
                                      @if (form.get('rate')?.hasError('invalidFormat')) {
                                        <mat-error>
                                          Please enter a valid number with up to 4 digits before the decimal and up to 2 digits after the
                                          decimal.
                                        </mat-error>
                                      }
                                    </div>
                                  }
                                </div>
                                <mat-divider></mat-divider>
                                @if (roleCheck(['Admin']) || roleCheck(['Accounting'])) {
                                  <div>
                                    <div class="add-rate">
                                      <a href="javascript:void(0)" (click)="addRate()" class="testing">
                                        <span><img src="/assets/icons/add_red.svg" alt="Add Rate" />&nbsp;Add Rate</span>
                                      </a>
                                    </div>
                                    <mat-divider></mat-divider>
                                  </div>
                                }
                                <div class="section-row col-md-12">
                                  <div class="col-8 label"><span>Total</span></div>
                                  <div class="col-1 dollar-symbol"><span>$</span></div>
                                  <div class="col-3">
                                    <mat-form-field appearance="outline">
                                      <input matInput type="number" [value]="calculateTotal()" disabled />
                                    </mat-form-field>
                                  </div>
                                </div>
                                <mat-divider></mat-divider>
                              </div>
                            }
                            <!-- non billable-->
                            <!-- This section will only be visible when isNonBillable is true -->
                            @if (isNonBillable && !isAddRates  && roleCheck(['Accounting','Admin'])) {
                              <div>
                                <!-- Top Section (Invoice Number, Invoice Date, etc.) -->
                                <div class="section-row col-md-12">
                                  <div class="col-9 label"><mat-label>Invoice Number</mat-label></div>
                                  <div class="col-3">
                                    <mat-form-field appearance="outline">
                                      <input matInput formControlName="invoiceNumber"  maxlength="15"/>
                                      <span class="input-icon">
                                        <img src="/assets/icons/Account-Receipt.svg" alt="Invoice Icon" />
                                      </span>
                                    </mat-form-field>
                                  </div>
                                </div>
                                <mat-divider></mat-divider>
                                <div class="section-row col-md-12">
                                  <div class="col-9 label"><mat-label>Invoice Date</mat-label></div>
                                  <div class="col-3">
                                    <mat-form-field appearance="outline" class="full-width">
                                      <input
                                        matInput
                                        [matDatepicker]="picker"
                                        formControlName="invoiceDate"
                                        (dateChange)="datechange($event.value)" />
                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                      </mat-form-field>
                                    </div>
                                  </div>
                                  <mat-divider></mat-divider>
                                  <div class="toggle-row">
                                    <span class="label">Invoice Sent</span>
                                    <mat-slide-toggle formControlName="invoiceSent"></mat-slide-toggle>
                                  </div>
                                  <mat-divider></mat-divider>
                                  <div class="toggle-row">
                                    <span class="label">Report Sent</span>
                                    <mat-slide-toggle formControlName="reportSent"></mat-slide-toggle>
                                  </div>
                                  <mat-divider></mat-divider>
                                </div>
                              }
                              <!-- This section will only be visible when isNonBillable is false -->
                              @if (!isNonBillable && !isAddRates && roleCheck(['Accounting','Admin'])) {
                                <div>
                                  <!-- Bottom Section: Add the content you want for when isNonBillable is false -->
                                  <!-- This could be a different form, or whatever content you want to display in this case -->
                                  <div class="section-row col-md-12">
                                    <div class="col-9 label"><mat-label>Invoice Number</mat-label></div>
                                    <div class="col-3">
                                      <mat-form-field appearance="outline">
                                        <input matInput formControlName="invoiceNumber"  maxlength="15"/>
                                        <span class="input-icon">
                                          <img src="/assets/icons/Account-Receipt.svg" alt="Invoice Icon" />
                                        </span>
                                      </mat-form-field>
                                    </div>
                                  </div>
                                  <mat-divider></mat-divider>
                                  <div class="section-row col-md-12">
                                    <div class="col-9 label"><mat-label>Invoice Date</mat-label></div>
                                    <div class="col-3">
                                      <mat-form-field appearance="outline" class="full-width">
                                        <input
                                          matInput
                                          [matDatepicker]="picker"
                                          formControlName="invoiceDate"
                                          (dateChange)="datechange($event.value)" />
                                          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                          <mat-datepicker #picker></mat-datepicker>
                                        </mat-form-field>
                                      </div>
                                    </div>
                                    <mat-divider></mat-divider>
                                    <div class="toggle-row">
                                      <span class="label">Invoice Sent</span>
                                      <mat-slide-toggle formControlName="invoiceSent"></mat-slide-toggle>
                                    </div>
                                    <mat-divider></mat-divider>
                                    <div class="toggle-row">
                                      <span class="label">Report Sent</span>
                                      <mat-slide-toggle formControlName="reportSent"></mat-slide-toggle>
                                    </div>
                                    <mat-divider></mat-divider>
                                  </div>
                                }
                              </div>
                            </div>
                          }
                        </form>
                      </div>
                      <div class="col-6">
                        @if (companyInformation) {
                          <app-accounting-info
                            [data]="companyInformation"
                            [billing]="billingInformation"
                            [notes]="notes"
                            [projectId]="projectId"
                            [additionalNotes]="additionalNotes"
                            (notesValue)="onNotedValue($event)">
                          </app-accounting-info>
                        }
                      </div>
                    </div>
                    <mat-divider></mat-divider>
                    @if (billingData) {
                      <mat-dialog-actions align="end" class="button-action">
                        <button mat-raised-button class="cancel-btn" (click)="cancel()">Cancel</button>
                        <button mat-raised-button color="primary" (click)="update()">UPDATE</button>
                      </mat-dialog-actions>
                    }
                  </div>
                </div>
              </div>
